import { render } from "./MultipleStatusPopUp.vue?vue&type=template&id=a449f670&scoped=true"
import script from "./MultipleStatusPopUp.vue?vue&type=script&lang=js"
export * from "./MultipleStatusPopUp.vue?vue&type=script&lang=js"

import "./MultipleStatusPopUp.vue?vue&type=style&index=0&id=a449f670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a449f670"]])

export default __exports__